import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ApprovalStatuses, DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFile from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentList, documentListForProject, getDownloadableLink, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation, useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { AttachFile } from "@mui/icons-material";
import { middleTruncate } from "../../helpers/string_helper";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitOtherDeliverableComment = ({ handleRejectModal, open, handleApproval, module, comment, selectedRow, handleClose }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [isReady, setIsReady] = useState(false);
  const [deliverableObject, setDeliverableObject] = useState({
    name: selectedRow?.deliverable.name ?? "",
    startDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate ? selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate : selectedRow?.deliverable.startDate,
    endDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate? selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate : selectedRow?.deliverable.endDate,
    description: selectedRow?.description ?? ""
  });
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [modal, setModal] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [mvpLoading, setMvpLoading] = useState(false)
  const [dealRoomLoading, setDealRoomLoading] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deletingFileType, setDeletingFileType] = useState('');
  const [mvpTestingFiles, setMvpTestingFiles] = useState([]);
  const [dealRoomFiles, setDealRoomFiles] = useState([]);
  const classes = useStyles();
  const [buttonLoading, setButtonLoading] = useState(false);
  const deliverableValidation = Yup.object().shape({
    comment: Yup.string()
      .max(2000, t("Comment can not be greater than 2000 characters"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please Enter Comment")),
  });
  useEffect(() => {
    if (selectedRow && !isReady) {
      setIsReady(true)
    }
  }, [selectedRow, isReady])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      comment: selectedRow?.approval?.comments || ""
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    // onSubmit: (values) => {
    //   handleUpdate();
    // }
  });

  useEffect(() => {
    if(selectedRow){
    getDocumentList()
    }
  },[selectedRow])



  const deliverableSubmit = async () => {
    try {
      const isValid = await formik.validateForm();
      if (Object.keys(isValid).length !== 0) {
        formik.setTouched({
          comment: true
        });
        return toast.error("Please fix the validation errors.");
      }
      setIsLoading(true);
      handleApproval(ApprovalStatuses.REJECTED, formik.values.comment)
      formik.resetForm({
        values: {
          comment: "",
        }
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  }
  if (!selectedRow) return null

  const getDocumentList = async () => {
      try {
        setLoadingDocument(true)
        setMvpLoading(true)
  
        let params = {
          projectId: selectedRow.project.id,
          filterFields: ['documentAssociations'],
          filterInputs: '',
          module: Modules.PROJECT_DELIVERABLE,
          moduleId: selectedRow.id
        };
        const documentData = await documentListForProject(params)
        const documentDataList = documentData.data.data;
  
        const filesByType = {
          'Non Legal': [],
          'MVP Testing': [],
          'DealRoom Registration': [],
        };
  
        documentDataList.forEach(doc => {
          const type = doc.documentType.name;
          if (filesByType[type]) {
            filesByType[type].push(doc);
          }
        });
  
        setSelectedFiles(filesByType['Non Legal']);
        formik.setFieldValue('attachmentId', filesByType['Non Legal'].map(f => f.id));
  
        setMvpTestingFiles(filesByType['MVP Testing']);
        formik.setFieldValue('mvpTestingattachmentId', filesByType['MVP Testing'].map(f => f.id));
  
        setDealRoomFiles(filesByType['DealRoom Registration']);
        formik.setFieldValue('dealRoomAttachmentId', filesByType['DealRoom Registration'].map(f => f.id));
      } catch (err) {
        console.log(err)
      }
      finally {
        setLoadingDocument(false)
        setMvpLoading(false)
        setDealRoomLoading(false)
      }
    }

  return (
    <>
    <Drawer
      anchor="right"
      open={open}
      onClose={handleRejectModal}
      className="projectListDrawer"
      PaperProps={{
        sx: { width: "580px" },
      }}
    >
      <form className="editMilestoneDrawer p-3">
        <h5>{t("Deliverable")}</h5>
        <CloseIcon className="crossIcon" onClick={handleRejectModal} />
        <div className="innerTbContent">
          <div className="row">
            {/* Name */}
            <div className="col-sm-12 mb-3">
              <TextField
                fullWidth
                id="outlined-basic"
                label={t("Name")}
                name="name"
                value={selectedRow?.deliverable?.name}
                inputProps={{
                  readOnly: true,
                }}
                required
              />
            </div>

            {/* Start Date */}
            <div className="col-sm-6 mb-3 plDatepicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  {deliverableObject.startDate && (
                    <DatePicker
                      label={t("Start Date") + " *"}
                      name="startDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate)
                          : dayjs(selectedRow?.deliverable?.startDate)
                      }
                      readOnly={
                        true
                      }
                      required
                    />

                  )}
                </DemoContainer>
              </LocalizationProvider>
            </div>

            {/* End Date */}
            <div className="col-sm-6 mb-3 plDatepicker">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  {deliverableObject.endDate && (
                    <DatePicker
                      label={t("End Date") + " *"}
                      name="endDate"
                      format="MM/DD/YYYY"
                      value={
                        selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate?.toString().trim()
                          ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate)
                          : dayjs(selectedRow?.deliverable?.endDate)
                      }
                      readOnly={
                        true
                      }
                      required
                    />
                  )}
                </DemoContainer>
              </LocalizationProvider>
            </div>

            {/* Description */}
            <div className="col-sm-12 mb-3">
              {/* {((action === Action.VIEW && deliverableObject.description !== "") || (action !== Action.VIEW) ? */}
              <>
                <TextField
                  fullWidth
                  className="form-control"
                  id="deliverable-title-input"
                  label={t("Description")}
                  name="description"
                  value={selectedRow?.description}
                  disabled={true}
                  multiline
                  required
                  rows={2}
                />
              </>
            </div>

            {selectedRow?.deliverable?.deliverableOrder === 4 &&
              <>
                <div className="col-sm-12 mb-3">
                  <>
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="mvpTesting"
                      label={t("MVP Testing")}
                      name="mvpTesting"
                      value={selectedRow?.mvpTesting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={true}
                    />
                  </>
                </div>

                {!mvpLoading && mvpTestingFiles.length > 0 && (
                  <h5 className="mb-0 mt-2">{t("Attached MVP Testing Documents")}:</h5>
                )}

                <div>
                  {mvpLoading && <Loader />}
                  {!mvpLoading && mvpTestingFiles.length > 0 && mvpTestingFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            }

            {/* Comment */}
            {!loadingDocument && selectedFiles.length > 0 && (
              <h5 className="mb-0 mt-2">{t("Attached Documents")}:</h5>
            )}

            <div>
              {loadingDocument && <Loader />}
              {!loadingDocument && selectedFiles.length > 0 && selectedFiles.map((file, key) => (
                <div className='d-flex mt-1 justify-content-between' key={key}>
                  <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                  <div className="actions">
                    <RemoveRedEyeOutlinedIcon
                      className={classes.blueIcon}
                      onClick={() => {
                        setModal(true);
                        setFilePath(getUrl(file.storageLink));
                        setFileName(middleTruncate(file.name));
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="col-sm-12 mb-3 mt-3">
              <TextField
                onWheel={(e) => e.target.blur()}
                fullWidth
                id="outlined-basic"
                label={t("Comment")}
                name="comment"
                multiline
                rows={3}
                value={formik.values.comment}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="text"
                disabled={isLoading}
                // onKeyDown={handleKeyDownWeight}
                required
              />
              {formik.touched.comment && formik.errors.comment && (
                <span className="text-danger">{formik.errors.comment}</span>
              )}
            </div>

          </div>
        </div>
        <div className="plsubmitButton justify-content-center mt-4">
          <Button
            onClick={() => {
              deliverableSubmit()
              handleClose()
            }}
            disabled={
              isLoading ||
              !(formik.values.comment)
            }
            className="btn addNew_ProjectBtn"
          >
            {isLoading && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-1"
              />
            )}
            {t("Submit")}
          </Button>
        </div>
      </form>
    </Drawer>
    {modal && (
      <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
    )}
    </>
  );
};

export default withTranslation()(SubmitOtherDeliverableComment);
